module.exports = __webpack_public_path__ + "images/company/badges/listed_badge_4b711396f462bf4f8bd4991d5262dbe3.svg";